export default {

    state: {
        loading: true,
        message: 'Kérem várjon!',
        usageHelpVisible: false,
        snackbar: false,
        snackbarMessage: '',
        snackbarStyle: 'success',
    },

    getters: {
        isLoading: (state) => state.loading,

        message: (state) => state.message,

        usageHelpVisible: (state) => state.usageHelpVisible,

        snackbar: (state) => state.snackbar,

        snackbarMessage: (state) => state.snackbarMessage,

        snackbarStyle: (state) => state.snackbarStyle,

        icon: (state) => {
            switch (state.snackbarStyle) {
            case 'success':
                return 'check';
            case 'error':
                return 'cross';
            default:
                return null;
            }
        },
    },

    mutations: {
        /* eslint-disable no-param-reassign */
        startLoading: (state) => {
            state.loading = true;
        },

        stopLoading: (state) => {
            state.loading = false;
        },

        setMessage: (state, message) => {
            state.message = message;
        },

        switchUsagehelpVisibility: (state) => {
            state.usageHelpVisible = !state.usageHelpVisible;
        },

        setNotificationMessage: (state, msg) => {
            state.snackbarMessage = msg;
        },

        setNotificationStyle: (state, style) => {
            state.snackbarStyle = style;
        },

        notify: (state) => {
            state.snackbar = true;
        },

        snackbar: (state, visible) => {
            state.snackbar = visible;
        },
        /* eslint-enable no-param-reassign */
    },

    actions: {
        pushNotification: (context, payload) => {
            context.commit('setNotificationMessage', payload.msg);
            context.commit('setNotificationStyle', payload.style);
            context.commit('notify');
        },
    },

};
